const useURLBuilder = () => {
  const buildUrl = (template: string, params: Record<string, string | number>): string => {
    return Object.keys(params).reduce((url, key) => url.replace(`{${key}}`, encodeURIComponent(params[key])), template);
  };
  return buildUrl;
};

export default useURLBuilder;